import { Pipe, PipeTransform } from '@angular/core';
import { TimeTrackingService } from '../Services/time-tracking.service';

@Pipe({
  name: 'formatTrackedTime'
})
export class FormatTrackedTimePipe implements PipeTransform {
  constructor(private timeTrackingService: TimeTrackingService){}
  // convert tracked time from '00:00:00' to '00 hrs 0 min' format
    transform(timeStamp: string): string {
    if (!timeStamp) return '00h 00m';
    let hours = parseInt(timeStamp.split(":")[0]);
        let min = parseInt(timeStamp?.split(":")[1]);
        if (!min) {
            min = 0;
        }
        return `${hours < 10 ? "0" + hours : hours}:${min < 10 ? "0" + min : min} h`;
  }

}
